import { AdPlacement } from "@/components/ads/AdPlacement";
import { CalcBreadcrumb } from "../components/CalcBreadcrumb";
import { CalcExplainer } from "../components/CalcExplainer";
import { PercentCalc } from "../components/PercentCalc";
import { RelatedCalculators } from "../components/RelatedCalculators";
import type { CalcDef } from "../lib/calculators";

/** Generic page for any single sub-calculator, rendered from its `CalcDef`. */
export function CalculatorPage({ def }: { def: CalcDef }) {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <CalcBreadcrumb current={def.navName()} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {def.h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {def.intro()}
          </p>
        </header>

        <PercentCalc config={def.config} />

        <CalcExplainer
          howTo={def.howTo()}
          examples={def.examples.map((e) => e())}
          faqs={def.faqs.map((f) => ({ q: f.q(), a: f.a() }))}
        />

        <AdPlacement className="mt-10" />
        <RelatedCalculators currentSlug={def.slug} />
      </div>
    </div>
  );
}
